import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Button, EmptyState, Info, Logo } from '@k1p4/ui'
import { LanguageSwitcher } from '../components/LanguageSwitcher'
import layout from '../layouts/AuthLayout.module.css'
import { useHomePath } from '../auth/useAuthEntry'
import { useDocumentTitle } from '../components/useDocumentTitle'

export function NotFound() {
  useDocumentTitle()
  const { t } = useTranslation()
  const home = useHomePath()

  return (
    <div className={layout.root}>
      <div className={layout.topbar}>
        <Link to={home} aria-label="k1p4">
          <Logo size={38} withWordmark withTagline />
        </Link>
        <LanguageSwitcher />
      </div>
      <main className={layout.main}>
        <EmptyState
          icon={<Info size={28} />}
          title={t('notFound.title')}
          description={t('notFound.body')}
          cta={
            <Link to={home}>
              <Button>{t('notFound.cta')}</Button>
            </Link>
          }
        />
      </main>
    </div>
  )
}
